import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneTopRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.68 20.82a2.64 2.64 0 0 1-1.87-.78l-4-4a2.65 2.65 0 0 1 3.31-4.13l.32.21 1.19-1.21-3.06-3a2.6 2.6 0 0 1-.79-1.9 2.68 2.68 0 0 1 .77-1.89 2.65 2.65 0 0 1 3.36-.32l4.12 2.78 2.67-2.67a3 3 0 1 1 4.21 4.21l-2.7 2.7 2.8 4.09a2.653 2.653 0 1 1-4.1 3.37l-3-3.08-1.19 1.18.21.32a2.65 2.65 0 0 1-2.21 4.12zm-4-7.33a.65.65 0 0 0-.65.645.64.64 0 0 0 .19.455l4 4a.65.65 0 0 0 1.1-.395.64.64 0 0 0-.11-.425l-.66-1a1 1 0 0 1 .12-1.26l2.48-2.47a1 1 0 0 1 1.41 0l3.8 3.87a.65.65 0 0 0 1-.82l-3.22-4.79a1 1 0 0 1 .12-1.26l3.26-3.33a1 1 0 1 0-1.41-1.41l-3.28 3.27a1 1 0 0 1-1.26.12l-4.8-3.23a.65.65 0 0 0-.8.08.63.63 0 0 0 0 .9l3.78 3.81a1 1 0 0 1 0 1.41l-2.48 2.48a1 1 0 0 1-1.26.12l-1-.66a.6.6 0 0 0-.36-.11z"
    />
  </svg>
);
export default SvgAirplaneTopRight;
